import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import { Button } from '@redshelf/redshelf-ui';

const useStyles = makeStyles((theme) => {
  return {
    /* Styles applied to the root element. */
    root: ({ shouldHaveBorderRadius }) => ({
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1.75, 2),

      letterSpacing: theme.typography.pxToRem(0.15),
      lineHeight: theme.typography.pxToRem(22),

      borderRadius: shouldHaveBorderRadius
        ? theme.spacing(0.5)
        : theme.spacing(0),
    }),
    action: ({ shouldHaveAction }) => ({
      marginRight: shouldHaveAction ? 0 : 'inherit',
    }),
    closeButton: {
      padding: theme.spacing(0.875, 2),
      fontSize: theme.typography.pxToRem(13),
      lineHeight: theme.typography.pxToRem(22),
      letterSpacing: '0.46px',
    },
    icon: {
      // not in the theme - #0288D1
      color: 'rgba(2, 136, 209, 1) !important',
    },
  };
});

const Message = ({
  className,
  text,
  icon,
  shouldHaveAction = false,
  shouldHaveBorderRadius = true,
  handleCloseClick = () => {},
  messageRef,
  ...props
}) => {
  const classes = useStyles({ shouldHaveBorderRadius, shouldHaveAction });

  return (
    <Alert
      classes={{
        action: classes.action,
        icon: classes.icon,
      }}
      className={clsx(className, classes.root)}
      icon={icon}
      ref={messageRef}
      severity="info"
      {...(shouldHaveAction
        ? {
            action: (
              <Button
                tabIndex={0}
                className={classes.closeButton}
                size="small"
                onClick={() => handleCloseClick()}
              >
                Close
              </Button>
            ),
          }
        : {})}
      {...props}
    >
      {text}
    </Alert>
  );
};

Message.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.element,
  shouldHaveAction: PropTypes.bool,
  handleCloseClick: PropTypes.func,
  messageRef: PropTypes.object,
};

export default Message;
